import { buildAeoDiscountCampaignConfig } from "app/components/AeoCampaignModal/configs/buildAeoDiscountCampaignConfig";
import { buildAnnualCampaignConfig } from "app/components/AnnualPromoModal/configs/buildAnnualCampaignConfig";
import type { IDiscountCampaignConfig } from "app/components/discountCampaign/DiscountBanner/types/discountCampaignConfig";
import { buildFirstWeekDiscountCampaignConfig } from "app/components/FirstWeekMonthlyPromo/configs/buildFirstWeekDiscountCampaignConfig";

/**
 * Ordered list of discount campaigns. The first entry whose `useDiscountCampaign`
 * reports `shouldShowCampaign === true` wins; if none is active, no banner / modal is shown.
 *
 * To add a new campaign:
 * 1. Implement `IDiscountCampaignConfig` (see `buildFirstWeekDiscountCampaignConfig` or
 *    `buildAeoDiscountCampaignConfig` for reference) and give it a stable `id`.
 * 2. Register the builder here in priority order.
 * 3. Add the campaign's modal component under the same `id` in `MarketingModals`.
 */
// `any` for the generic parameter so the array can hold configs with different
// `T`s (e.g. AeoCampaignType vs string). Each entry keeps its own narrow T
// internally; `useDiscountCampaign` re-infers T at the call site, so type
// safety is preserved where it matters.

export const buildRegisteredDiscountCampaignConfigs = (): IDiscountCampaignConfig<any>[] => [
    buildFirstWeekDiscountCampaignConfig(),
    buildAeoDiscountCampaignConfig(),
    buildAnnualCampaignConfig(),
];
